<script lang="ts">
import VCheckbox         from '@/lib/components/VCheckbox/VCheckbox.vue';
import VCheckboxGroup    from '@/lib/components/VCheckboxGroup/VCheckboxGroup.vue';

export default defineComponent({
	name: "CheckboxesSample",

	components: {
		VCheckbox,
		VCheckboxGroup
	},

	data() {
		return {
			value: { id: 2, name: 'Второй' },
			options : new Array(5).fill(null).map((v, i) => {
				return {
					name: "Option " + i,
					id: i,
					label: 'label ' + i
				};
			})
		}
	}
});
</script>

<template>
	<div class="content__checkboxes">
		<div class="content__checkbox-group">
			<h3 class="content__subtitle">VCheckbox</h3>
			<VCheckbox v-model="value">Checkbox text</VCheckbox>
		</div>
		<div class="content__checkbox-group">
			<h3 class="content__subtitle">VCheckboxGroup - Vertical</h3>
			<VCheckboxGroup
				v-model="value"
				:options="options"
				option-label="name"
				checkbox-layout="vertical"
			/>
		</div>
		<div class="content__checkbox-group">
			<h3 class="content__subtitle">VCheckboxGroup - Horizontal</h3>
			<VCheckboxGroup
				v-model="value"
				:options="options"
				option-label="name"
				checkbox-layout="horizontal"
			/>
		</div>
		<div class="content__checkbox-group">
			<h3 class="content__subtitle">VCheckboxGroup - Button Layout</h3>
			<VCheckboxGroup
				v-model="value"
				:options="options"
				option-label="name"
				checkbox-layout="buttons"
				type-radio
			/>
		</div>
	</div>
</template>
